// sent_at komt uit SQLite als UTC zonder zone: "YYYY-MM-DD HH:MM:SS".
const formatSentAt = (sentAt) =>
  new Date(sentAt.replace(' ', 'T') + 'Z').toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' })

const MeetupStatusBadge = ({ meetup }) => {
  if (!meetup.published) {
    return (
      <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300">
        Concept
      </span>
    )
  }

  return (
    <div className="space-y-0.5">
      <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300">
        Gepubliceerd
      </span>
      <div className="text-xs text-gray-500 dark:text-gray-400">
        Uitnodiging: {meetup.invitation_sent_at ? formatSentAt(meetup.invitation_sent_at) : 'nog niet verstuurd'}
      </div>
      {meetup.reminder_sent_at && (
        <div className="text-xs text-gray-500 dark:text-gray-400">
          Herinnering: {formatSentAt(meetup.reminder_sent_at)}
        </div>
      )}
    </div>
  )
}

export default MeetupStatusBadge
